import React from "react"
import PropTypes from "prop-types"
import Link from "../UI/Link/Link"
import * as style from "./MultiColumnGridWithTextOrLink-tw-styles"
import { get } from "../../helpers/utils"
import LinksWithContent from "../LinksWithContent/LinksWithContent"
import Video from "../UI/Video/Video"
import MultiRowTable from "../MultiRowTable/MultiRowTable"
import Typography from "../UI/Typography/Typography"
import variants from "../../constants/variants.constants"
import ImageCardsLayout from "../ImageCardsLayout/ImageCardsLayout"
import TextContent from "../TextContent/TextContent"
import Image from "../UI/Image/Image"

const MultiColumnGridWithTextOrLink = props => {
  const {
    heading,
    textCardsCollection,
    linksCollection,
    variant,
    elementId = "",
  } = props
  const styles = style[variant] || style.defaultStyle
  const cardArr = textCardsCollection && get(textCardsCollection, "items", [])
  const linkArr = linksCollection && get(linksCollection, "items", [])
 
  return (
    <div className={styles?.mainContainerWrapper} id={elementId}>
      <div className={styles?.containerWrapper}>
        {heading && (
          <div className={styles?.headingWrapper}>
            <h2 className={styles?.Heading}>{heading}</h2>
          </div>
        )}
        <div className={styles?.container}>
          {cardArr?.length > 0 &&
            cardArr?.map((item, index) => (
              <div className={styles?.Content} key={index}>
                {variant === variants?.TWO_COLUMN_LINKS_BG_WHITE &&
                
                item?.title &&
                item?.link?.url ? (
                  <div>
                    {item?.title && (
                      <Typography
                        content={item?.title}
                        className={styles?.title}
                      />
                    )}
                    {item?.description && (
                      <div className={styles?.description}>
                        <Typography
                          allow_br_tag={true}
                          content={item?.description}
                          className={styles?.descriptionText}
                        />
                      </div>
                    )}
                    {item?.link && (
                      <Link
                        {...item?.link}
                        className={styles?.descriptionLink}
                      ></Link>
                    )}
                  </div>
                ) : (
                  <div>
                    {item?.title && item?.link?.url && (
                      <Link
                        url={item?.link?.url}
                        target={item?.link?.target}
                        ariaLabel={item?.link?.areaLabel}
                        className={styles?.title}
                      >
                        <Typography
                           content={item?.title}
                         />
                      </Link>
                    )}
                  </div>
                )}
                {variant === variants?.TWO_COLUMN_LINKS_SMALL_TITLE &&
                  item?.link && (
                    <div className={styles?.mediaVideoLink}>
                      <Link {...item?.link}></Link>
                    </div>
                  )}

                {!item?.link?.url && !item?.link?.images?.imageDesktop?.url && (
                  <div>
                    {variant === variants?.COCOA_LIFE_PILLER_DESCRIPTION &&
                     item?.image?.imageDesktop && (
                      <Image
                        src={item?.image?.imageDesktop?.url}
                      />
                    )}
                    
                    {item?.title && (
                      <Typography
                        content={item?.title}
                        className={styles?.title}
                      />
                    )}
                    {item?.description && (
                      <div className={styles?.description}>
                        <Typography
                          content={item?.description}
                          className={styles?.descriptionText}
                          allow_br_tag={true}
                        />
                      </div>
                    )}
                    {item?.link && <Link {...item?.link}></Link>}
                  </div>
                )}

                {item?.video && (
                  <div>
                    <Video {...item?.video}></Video>
                  </div>
                )}
              </div>
            ))}
        </div>

        <div
          className={
            variant === variants.THREE_COLUMN_VIDEO
              ? styles?.marketingApproachWrapper
              : styles?.multirowTable
          }
        >
          {props?.items?.map((data, index) => {
            return (
              <div key={index}>
                <div className={style?.[data.variant]?.containerWrapper}>
                  {data?.textCardsCollection?.items?.length > 0 && (
                    <div>
                      {data?.heading && (
                        <h1 className={style?.[data.variant]?.Heading}>
                          {" "}
                          {data?.heading}
                        </h1>
                      )}
                      {data?.textCardsCollection?.items?.map((item, idx) => {
                        return (
                          <div key={idx} className="markettingApproachBtn">
                            {item?.title && (
                              <Typography
                                className={style?.description}
                                allow_br_tag={true}
                                content={item?.title}
                              ></Typography>
                            )}
                            {item?.video && <Video {...item?.video}></Video>}
                            {item?.textContentCollection &&
                              item?.textContentCollection?.items?.map(
                                (data, idx) => (
                                  <TextContent {...data} key={idx} />
                                )
                              )}
                            {item?.description && (
                              <Typography
                                className={
                                  style?.[data?.variant]?.descriptionText
                                }
                                allow_br_tag={true}
                                content={item?.description}
                              ></Typography>
                            )}
                            {item?.link && (
                              <LinksWithContent
                                {...item?.link}
                                variant={data?.variant}
                              ></LinksWithContent>
                            )}
                            {item?.imageCardLayout && (
                              <ImageCardsLayout
                                {...item?.imageCardLayout}
                              ></ImageCardsLayout>
                            )}
                          </div>
                        )
                      })}
                    </div>
                  )}
                </div>
                {data?.multiRowTable?.length !== null && (
                  <MultiRowTable {...data?.multiRowTable}></MultiRowTable>
                )}
              </div>
            )
          })}
        </div>
        {linkArr?.length > 0 && (
          <div className={styles?.linkContainer}>
            <div className={styles?.linkwrap}>
              {linkArr?.map((item, index) => (
                <LinksWithContent {...item} key={index} />
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

MultiColumnGridWithTextOrLink.propTypes = {
  heading: PropTypes.string,
  textCardsCollection: PropTypes.any,
  linksCollection: PropTypes.object,
  variant: PropTypes.string,
  elementId: PropTypes.string,
  items: PropTypes.array,
}

export default MultiColumnGridWithTextOrLink
